import axios from "axios";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// ===================================
//  LOCATIONS
// ===================================
export const locationsAreLoading = () => {
	return {
		type: "LOCATIONS_ARE_LOADING"
	};
};

export const locationsHasError = err => {
	return {
		type: "LOCATIONS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const locationsSuccess = data => {
	return {
		type: "LOCATIONS_SUCCESS",
		payload: data.data
	};
};

export function getLocations(isShipping = false) {
	return dispatch => {
		dispatch(locationsAreLoading());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		return axios
			.get(REACT_APP_API_URL + `locations?isShipping=${isShipping}`, { headers: AUTH_HEADER })
			.then(response => dispatch(locationsSuccess(response)))
			.catch(err => {
				console.log("getLocations error:", err.response.statusText);
				dispatch(locationsHasError(err.response.statusText));
			});
	};
}

// ===================================
//  PROVINCES
// ===================================
export const provincesAreLoading = () => {
	return {
		type: "PROVINCES_ARE_LOADING"
	};
};

export const provincesHasError = err => {
	return {
		type: "PROVINCES_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const provincesSuccess = data => {
	return {
		type: "PROVINCES_SUCCESS",
		payload: data.data
	};
};

export function getProvinces(country, isShipping = false) {
	return dispatch => {
		dispatch(provincesAreLoading());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		// Possibly ask for a specific country
		const params = !!country ? { country: country, isShipping: isShipping } : { country: "US" };

		return axios
			.get(REACT_APP_API_URL + "locations/provinces", { headers: AUTH_HEADER, params: params })
			.then(response => dispatch(provincesSuccess(response)))
			.catch(err => {
				console.log("getProvinces error:", err.response.statusText);
				dispatch(provincesHasError(err.response.statusText));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/locations.js